import React from 'react'
import {
  PhoneNumberInput,
  VerifyPhoneNumberFailureFragment,
} from 'src/graphql/generated/graphql'
import {
  Anchor,
  Button,
  Flex,
  Icon,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'

const GenericError = (props: {
  failure: VerifyPhoneNumberFailureFragment
  getNewCode: (phoneNumber?: PhoneNumberInput) => void
  tryAgain: () => void
}) => {
  const { getNewCode, tryAgain, failure } = props

  return (
    <div>
      <Spacer space="x4" />
      <Flex
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
      >
        <Icon name="exclamation" size="xLarge" primaryColor="danger" />
        <>
          <Spacer space="x3" />
          <Text type="subtitle" weight="bold">
            There was an error validating your phone number
          </Text>
          <Spacer space="x2" />
          <Text type="caption" alignment={'center'}>
            {failure.failureMessage}
          </Text>
          <Spacer space="x3" />
          <Text type="caption" alignment="left">
            For further assistance, contact the Customer Success team at
            <b> (801) 463-3800 </b>
            to resolve this issue.
          </Text>
        </>
      </Flex>
      <Spacer space="x2" />
      <Flex justifyContent="center" flexDirection="column" alignItems="center">
        <Button
          title={'Get a new code'}
          onClick={() => getNewCode(undefined)}
          outlined={true}
          type="shadow"
          hover={true}
        />
        <Spacer space="x2" />
        <Anchor
          title="Try my code again"
          size="small"
          onClick={tryAgain}
          isDecorated={true}
        />
      </Flex>
    </div>
  )
}

export default GenericError
